import {
  CLICKING_ON_ITEM_OPTIONS,
  LAYOUTS,
  COLLAGE_POST_SIZE,
  DISPLAY_ON_HOVER,
  DESK_FEED_MAX_SPACING,
  DESK_FEED_GRID_MAX_COLUMNS,
  DESK_FEED_SLIDER_MAX_COLUMNS,
} from '../../constants/settingsConstants';
import {
  instagramStyleParams,
  expandInstagramStyles,
  mobileStyleParams,
} from '../../settings';
import WixService from '../services/WixService';

const compId = WixService.getCompId();
let isFullWidth = false;

const key = `settings${compId}`;

export const getIsFullWidth = () => {
  return WixService.getDataPublic(key)
    .then((dataPublicSettings) => {
      isFullWidth = dataPublicSettings[key]?.desktop_layout_full_width || false;
    })
    .catch(() => {
      isFullWidth = false;
    });
};

const getWixColor = (name, opacity = 1) => {
  return { opacity, name };
};

const addParams = (newKey, value, correctStyleParams) => {
  return {
    newKey,
    value,
    correctStyleParams: correctStyleParams[newKey],
  };
};

export const EXPAND_PARAMS = [
  'e_isDisplayCaption',
  'e_panelColor',
  'e_primaryColor',
  'e_seconderyColor',
  'e_dividers',
];

export const getDefaultParams = () => {
  return [
    addParams('isDisplayProfileInfo', false, instagramStyleParams),
    addParams('m_isDisplayProfileInfo', false, mobileStyleParams),
    addParams('isDisplayHashtagsFeed', false, instagramStyleParams),
    addParams('m_isDisplayHashtagsFeed', false, mobileStyleParams),
    addParams(
      'displayOnHover',
      DISPLAY_ON_HOVER.CAPTIONS,
      instagramStyleParams,
    ),
    addParams('spacingGrid', 10, instagramStyleParams),
    addParams('spacingCollage', 10, instagramStyleParams),
    addParams('spacingSlider', 10, instagramStyleParams),
    addParams('gallerySpacingGrid', 0, instagramStyleParams),
    addParams('gallerySpacingCollage', 0, instagramStyleParams),
    addParams('gallerySpacingSlider', 0, instagramStyleParams),
    addParams('m_gallerySpacingCollage', 0, mobileStyleParams),
    addParams('m_gallerySpacingGrid', 0, mobileStyleParams),
    addParams('m_gallerySpacingSlider', 0, mobileStyleParams),
    addParams('appBgColor', getWixColor('color_11', 0), instagramStyleParams),
    addParams('feedBgColor', getWixColor('color_11', 0), instagramStyleParams),
    addParams('numberOfColumnsGrid', isFullWidth ? 5 : 3, instagramStyleParams),
    addParams(
      'collagePostSize',
      isFullWidth ? COLLAGE_POST_SIZE.XSMALL : COLLAGE_POST_SIZE.MEDIUM,
      instagramStyleParams,
    ),
    addParams('rowsLoadMoreCollage', 2, instagramStyleParams),
    addParams('numberOfColumnsSlider', 4, instagramStyleParams),
  ];
};

export const isInstagramV4 = (styles) => {
  if (styles.isNewStyles) {
    return false;
  }
  if (styles.plusColorOpacity) {
    return true;
  }
  return WixService.getDataPublic(key)
    .then((dataPublicSettings) => {
      if (dataPublicSettings && dataPublicSettings[key]) {
        return (
          (styles.adiSelectedPreset && !dataPublicSettings[key]?.isV5Version) ||
          false
        );
      } else {
        return false;
      }
    })
    .catch(() => {
      return false;
    });
};

const getCurrentBlocks = (value) => {
  switch (value) {
    case 2:
    case 3:
      return 1;
    case 4:
    case 5:
      return 2;
    case 6:
    case 7:
    case 8:
      return 3;
    default:
      return 1;
  }
};

export const convertStyleParams = (key, value) => {
  const arr = [];

  switch (key) {
    // Layout
    case 'columnsGridFalse':
    case 'columnsGridTrue':
      if (
        (key === 'columnsGridTrue' && isFullWidth) ||
        (key === 'columnsGridFalse' && !isFullWidth)
      ) {
        arr.push(
          addParams(
            'numberOfColumnsGrid',
            value > DESK_FEED_GRID_MAX_COLUMNS
              ? DESK_FEED_GRID_MAX_COLUMNS
              : value,
            instagramStyleParams,
          ),
        );
      }
      break;
    case 'rowsGridFalse':
    case 'rowsGridTrue':
      if (
        (key === 'rowsGridTrue' && isFullWidth) ||
        (key === 'rowsGridFalse' && !isFullWidth)
      ) {
        arr.push(addParams('numberOfRowsGrid', value, instagramStyleParams));
      }
      break;
    case 'numImagesSliderFalse':
    case 'numImagesSliderTrue':
      if (
        (key === 'numImagesSliderTrue' && isFullWidth) ||
        (key === 'numImagesSliderFalse' && !isFullWidth)
      ) {
        arr.push(
          addParams(
            'numberOfColumnsSlider',
            value > DESK_FEED_SLIDER_MAX_COLUMNS
              ? DESK_FEED_SLIDER_MAX_COLUMNS
              : value,
            instagramStyleParams,
          ),
        );
      }
      break;
    case 'rowsCollageFalse':
    case 'rowsCollageTrue':
      if (
        (key === 'rowsCollageTrue' && isFullWidth) ||
        (key === 'rowsCollageFalse' && !isFullWidth)
      ) {
        arr.push(
          addParams(
            'rowsLoadMoreCollage',
            getCurrentBlocks(value),
            instagramStyleParams,
          ),
        );
      }
      break;
    case 'columnsCollageFalse':
    case 'columnsCollageTrue':
      if (
        (key === 'columnsCollageTrue' && isFullWidth) ||
        (key === 'columnsCollageFalse' && !isFullWidth)
      ) {
        arr.push(
          addParams(
            'collagePostSize',
            value === 3
              ? COLLAGE_POST_SIZE.LARGE
              : value === 4
              ? COLLAGE_POST_SIZE.MEDIUM
              : value === 5
              ? COLLAGE_POST_SIZE.SMALL
              : COLLAGE_POST_SIZE.XSMALL,
            instagramStyleParams,
          ),
        );
      }
      break;
    case 'spacingGrid':
    case 'spacingCollage':
    case 'spacingSlider':
      arr.push(
        addParams(
          key,
          value > DESK_FEED_MAX_SPACING ? DESK_FEED_MAX_SPACING : value,
          instagramStyleParams,
        ),
      );
      break;

    // Settings
    case 'showMoreDesktop':
      arr.push(addParams('isShowMoreBtn', value, instagramStyleParams));
      arr.push(addParams('isShowMoreBtnCollage', value, instagramStyleParams));
      break;
    case 'popupDisplay':
      arr.push(
        addParams(
          'clickingOnItem',
          value
            ? CLICKING_ON_ITEM_OPTIONS.OPEN_EXPAND
            : CLICKING_ON_ITEM_OPTIONS.NOTHING_APPENED,
          instagramStyleParams,
        ),
      );
      break;

    // Display
    case 'captionToggle':
      arr.push(addParams('isHoverPost', value, instagramStyleParams));
      break;
    case 'descriptionCheckbox':
      arr.push(addParams('e_isDisplayCaption', value, expandInstagramStyles));
      break;

    // Design
    case 'showMoreColorGrid':
      arr.push(
        addParams(
          'buttonBorderColor',
          { ...value, opacity: 1 },
          instagramStyleParams,
        ),
      );
      break;
    case 'expandTheme':
      if (value === 1) {
        arr.push(
          addParams(
            'e_panelColor',
            getWixColor('color_15'),
            expandInstagramStyles,
          ),
        );
        arr.push(
          addParams(
            'e_primaryColor',
            getWixColor('color_11'),
            expandInstagramStyles,
          ),
        );
        arr.push(
          addParams(
            'e_seconderyColor',
            getWixColor('color_12'),
            expandInstagramStyles,
          ),
        );
        arr.push(
          addParams(
            'e_dividers',
            getWixColor('color_11', 0.3),
            expandInstagramStyles,
          ),
        );
      }
      break;

    // Mobile
    // Layout
    case 'mobileLayoutType':
      switch (value) {
        case 1:
        case 2:
        case 3:
          arr.push(
            addParams('m_galleryLayout', LAYOUTS.GRID, mobileStyleParams),
          );
          arr.push(
            addParams('m_numberOfColumnsGrid', value, mobileStyleParams),
          );
          arr.push(addParams('m_numberOfRowsGrid', 4, mobileStyleParams));
          break;
        case 4:
          arr.push(
            addParams('m_galleryLayout', LAYOUTS.SLIDER, mobileStyleParams),
          );
          arr.push(addParams('m_numberOfColumnsSlider', 1, mobileStyleParams));
          break;
        default:
          break;
      }
      break;
    case 'mobileRowsGrid':
      arr.push(addParams('m_numberOfRowsGrid', value, mobileStyleParams));
      break;
    case 'mobileSpacingGrid':
      arr.push(addParams('m_spacingItemsGrid', value, mobileStyleParams));
      break;

    // Settings
    case 'mobileShowMoreGrid':
      arr.push(addParams('m_isShowMoreBtn', value, mobileStyleParams));
      break;

    default:
      break;
  }

  return arr;
};
